"use client";

import React from "react";
import { Rocket, Briefcase, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const audiences = [{
  id: "regenerative",
  title: "Regenerative Medicine",
  description: "Experience world-class cellular therapies in our serene Limassol facility, where architectural elegance meets the frontier of healing science.",
  linkText: "View Treatments",
  linkUrl: "/TreatmentsPage",
  iconName: "Rocket"
}, {
  id: "diagnostics",
  title: "Precision Diagnostics",
  description: "Our Nicosia suite provides clinical clarity through advanced imaging and biomarker analysis, creating your personalized roadmap to optimal health.",
  linkText: "Common Conditions",
  linkUrl: "/ConditionsPage",
  iconName: "Briefcase"
}, {
  id: "longevity",
  title: "Longevity & Wellness",
  description: "Integrating traditional wisdom with modern longevity protocols across our Cyprus locations to achieve total body harmony and vitality.",
  linkText: "Health Insights",
  linkUrl: "/HealthInsightsPage",
  iconName: "TrendingUp"
}];
const iconMap: Record<string, React.ElementType> = {
  Rocket,
  Briefcase,
  TrendingUp
};
export default function WhoWeHelp() {
  return <section data-section-id="150295" id="related-services" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary">
            Our Specialized Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {audiences.map((audience, i) => {
          const IconComponent = iconMap[audience.iconName];
          return <div data-index={i} key={audience.id} className="h-full">
                <Card className="h-full flex flex-col bg-card/70 backdrop-blur-md border border-border/40 shadow-xl rounded-xl transition-transform duration-500 ease-in-out hover:scale-105">
                  <CardHeader className="pb-4">
                    {IconComponent && <IconComponent className="size-12 text-accent stroke-[1.5] mb-4" />}
                    <CardTitle className="text-[28px] text-primary font-serif leading-tight">
                      {audience.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="text-[18px] font-sans text-foreground/80 leading-relaxed">
                      {audience.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 mt-auto">
                    <Link to={audience.linkUrl} className="inline-flex items-center gap-2 text-accent font-semibold hover:opacity-80 transition-opacity group">
                      {audience.linkText}
                      <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}